'use strict';

import ChatBox from './chatbox';

const ControllerNameEnum = {
    controllerLeft: 'controllerLeft',
    controllerRight: 'controllerRight',
};

class ChatBoxController {
    constructor() {
        this.chatBoxVisibilityButtonRightController = null;
        this.chatBoxVisibilityButtonLeftController = null;
        this.chatBoxVisibilityButtonImageSrc = 'chatNotificationOnXR.svg';
        this.chatBoxVisibilityButtonName = 'chatBoxButton';
        this.imageBasePath = 'toolbarIcons';
        this.defaultNameColor = {
            b: 0.431373,
            g: 0.431373,
            r: 0.431373,
        };
        this.systemName = 'System';
        this.systemNameColor = '#FFA500';
        this.systemId = '-1';
        this.chatBoxContainer = null;
        this.audioBasePath = 'sounds';
        this.notificationAudioFileName = this.audioBasePath + "\\" + 'chatNotification.mp3';
        this.notificationAudio = {
            source: this.notificationAudioFileName,
            volume: 20.0,
            loop: false,
            shouldStopCurrentlyPlayingNotificationAudio: true,
        };
        this.notificationAudioController = new NotificationAudioController(this.notificationAudio);
    }

    createNewChatBox() {
        this.chatBoxContainer = new ChatBox({
            fullChatBoxDiv: {
                id: 'fullChatBox',
                class: 'FullChatBox',
                name: 'fullChatBox',
            },
            chatBoxMessagesDiv: {
                id: 'chatBoxMessages',
                class: 'ChatBoxMessages',
                name: 'chatBoxMessages',
            },
            chatBoxBottomPanelDiv: {
                id: 'chatBoxBottomPanel',
                class: 'ChatBoxBottomPanel',
                name: 'chatBoxBottomPanel',
            },
            chatBoxTopPanelDiv: {
                id: 'chatBoxTopPanel',
                class: 'ChatBoxTopPanel',
                name: 'chatBoxTopPanel',
            },
            backgroundColor: rgbToHexColorCode(wv.settings.chatBox.backgroundColor.r, wv.settings.chatBox.backgroundColor.g, wv.settings.chatBox.backgroundColor.b),
            messageTextColor: rgbToHexColorCode(wv.settings.chatBox.chatTextColor.r, wv.settings.chatBox.chatTextColor.g, wv.settings.chatBox.chatTextColor.b),
            totalWidth: 400,
            totalHeight: 480,
            messagePanelHeight: 400,
            bottomPanelHeight: 50,
            topPanelHeight: 30,

        });
    }

    updateChatBoxContainerTextAreaStatus(enabled) {
        this.chatBoxContainer.updateChatTextAreaStatus(enabled);
    }

    getChatTextAreaStatus() {
        return this.chatBoxContainer.getChatTextAreaStatus();
    }

    updateChatBoxButtonVisibilityOnPresenterChange() {
        if (!FeatureAccessController.hasAccess(FeatureEnum.CHATBOX)) {
            this.setChatBoxButtonVisibility(false);
        } else {
            this.setChatBoxButtonVisibility(true);
        }
    }

    setChatBoxButtonVisibility(isVisible) {
        this.chatBoxVisibilityButtonRightController.visible = isVisible;
        this.chatBoxVisibilityButtonLeftController.visible = isVisible;
    }

    async getChatBoxVisibilityButtonTexture(imagePath) {
        let chatBoxVisibilityButtonPicture = new Picture2D.Picture(new Picture2D.Image(imagePath), 256, 256);
        await chatBoxVisibilityButtonPicture.paint();

        let chatBoxVisibilityButtonTexture = new THREE.CanvasTexture(chatBoxVisibilityButtonPicture.canvas);
        chatBoxVisibilityButtonTexture.colorSpace = THREE.SRGBColorSpace;
        chatBoxVisibilityButtonTexture.needsUpdate = true;
        return chatBoxVisibilityButtonTexture;
    }

    async createChatBoxVisibilityButton() {
        const chatBoxVisibilityButtonImagePath = this.imageBasePath + "\\" + this.chatBoxVisibilityButtonImageSrc;
        const chatBoxVisibilityButtonTexture = await this.getChatBoxVisibilityButtonTexture(chatBoxVisibilityButtonImagePath);

        let chatBoxVisibilityButtonMaterial = new THREE.MeshBasicMaterial({
            map: chatBoxVisibilityButtonTexture,
            opacity: 1.0,
            transparent: true,
            side: THREE.DoubleSide
        });
        chatBoxVisibilityButtonMaterial.map.minFilter = THREE.LinearFilter;
        const chatBoxVisibilityButtonGeometry = new THREE.CircleGeometry(1, 64);

        this.chatBoxVisibilityButtonRightController = new THREE.Mesh(chatBoxVisibilityButtonGeometry, chatBoxVisibilityButtonMaterial);

        const CIRCLE_RADIUS = 0.0206718;
        this.chatBoxVisibilityButtonRightController.scale.set(CIRCLE_RADIUS, CIRCLE_RADIUS, 1);
        this.chatBoxVisibilityButtonRightController.renderOrder = RenderOrderEnum.SecondaryMenuRO;
        this.chatBoxVisibilityButtonRightController.rotation.x = -Math.PI / 2;
        this.chatBoxVisibilityButtonRightController.visible = true;

        this.chatBoxVisibilityButtonRightController.name = this.chatBoxVisibilityButtonName;
        this.chatBoxVisibilityButtonRightController.parentName = ControllerNameEnum.controllerRight;

        this.chatBoxVisibilityButtonRightController.position.set(0.04, 0.007, 0.19);
        this.chatBoxVisibilityButtonRightController.showSelectionCircle = true;
        wv.controllerRight.add(this.chatBoxVisibilityButtonRightController);

        this.chatBoxVisibilityButtonLeftController = this.chatBoxVisibilityButtonRightController.clone();
        this.chatBoxVisibilityButtonLeftController.position.set(-0.04, 0.007, 0.19);
        this.chatBoxVisibilityButtonLeftController.parentName = ControllerNameEnum.controllerLeft;
        this.chatBoxVisibilityButtonLeftController.showSelectionCircle = true;
        wv.controllerLeft.add(this.chatBoxVisibilityButtonLeftController);
    }

    addMenu(parentMenuController, prop, isPresenter) {
        if (wv.MessagingFeatureMenuItem === undefined) {
            wv.MessagingFeatureMenuItem = new MenuData(prop.text || MessagingMenu.text, 4, 4);

            let menuController = new MenuController(wv.MessagingFeatureMenuItem);
            menuController.setMenuControlParameter(VR.scene, iq3Camera.camera, wv.selectionSphere);
            wv.MessagingFeatureMenuItem.selectionCloseMenuForSingleSelection = true;

            parseChildrenItems(menuController, prop.children, menuItemMaps.chatBoxMenuItemMap);
        }
        wv.MessagingFeatureMenuItem.isViewer = prop.isViewer;
        wv.MessagingFeatureMenuItem.isPresenter = prop.isPresenter;
        wv.MessagingFeatureMenuItem.isVisible = prop.isVisible;
        parentMenuController.appendMenuItem(MessagingMenu.menuItemName, prop.text || MessagingMenu.text, wv.MessagingFeatureMenuItem);
    }

    onFeatureChange(value) {
        this.chatBoxContainer.toggleChatboxVisibility();
        checkBoxSyncVR('chatBoxVisibility', value);
        wv.pinMenuController.resetVisibility();
    }

    handleMouseDown(event) {
        let pick = event.pickingData;
        let object = pick.object;

        if (!object) {
            return false;
        }

        if (object.name === this.chatBoxVisibilityButtonName) {
            this.chatBoxContainer.toggleChatboxVisibility();
            return true;
        }

        return this.chatBoxContainer.handleMouseDown(object, pick.point);
    }

    handleControllerTriggerDown(controller) {
        setControllerRaycaster(controller);

        let objectArr = [];
        objectArr.push(this.chatBoxVisibilityButtonRightController);
        objectArr.push(this.chatBoxVisibilityButtonLeftController);
        if (this.chatBoxContainer.fullChatBox.children.length > 0 && this.chatBoxContainer.fullChatBox.visible) {
            objectArr.push(...this.chatBoxContainer.fullChatBox.children);
        }

        let intersects = raycast.intersectObjects(objectArr);

        let object, pickedPoint;
        if (intersects.length > 0) {
            object = intersects[0].object;
            pickedPoint = intersects[0].point;
        } else {
            return false;
        }

        if (object.name === this.chatBoxVisibilityButtonName) {
            this.onFeatureChange(!wv.effectController.isChatBoxVisible);
            this.addChatBoxToController(object.parentName);
            return true;
        }

        return this.chatBoxContainer.handleControllerTriggerDown(object, pickedPoint);
    }

    getSenderDetails(senderId) {
        let senderColor, senderName;
        if (!senderId || senderId === this.systemId) {
            senderName = this.systemName;
            senderColor = this.systemNameColor;
        } else {
            const sender = wv.effectController.Participants[senderId] || wv.effectController.RegisteredParticipants[senderId];
            if (!sender) {
                senderName = "Participant_" + senderId;
                senderColor = this.defaultNameColor;
            } else {
                senderColor = wv.effectController.ParticipantsColor[senderId];
                senderName = sender.name;
            }

        }

        return {
            senderName: senderName,
            senderId: senderId,
            senderColor: senderColor,
        };
    }

    addNewMessage(messageObject) {
        if (!wv.effectController.isChatBoxVisible) {
            this.chatBoxContainer.allMessagesRead = false;
        } else {
            this.chatBoxContainer.messages.push({
                senderName: messageObject.senderDetails.senderName,
                senderColor: messageObject.senderDetails.senderColor,
                message: messageObject.message,
            });
        }
        this.chatBoxContainer.allMessagesUpdated = false;
        menuViewToolbarController.updateMessageButton(wv.effectController.isChatBoxVisible);
        menuViewToolbarController.updateShow2dToolbarIcon();
        if (!wv.effectController.isChatBoxVisible) {
            this.notificationAudioController.play();
        }
    }

    handleChatOnEnterKey() {
        if (this.chatBoxContainer.chatTextAreaActive) {
            this.chatBoxContainer.sendChat();
        }
    }

    addChatBoxToController(controllerName) {
        if (controllerName === ControllerNameEnum.controllerRight) {
            this.chatBoxContainer.addChatBoxToControllerRight();
        } else {
            this.chatBoxContainer.addChatBoxToControllerLeft();
        }
    }
}

export default ChatBoxController;
